/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Logo_HintInputs */

const cs_settings_office_logo_hint = /** @type {(inputs: Settings_Office_Logo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WebP nebo SVG. Nahradí výchozí značku Cerebrio v aplikaci, na veřejném webu a v katalogových dokumentech. Nejde o fotografii v galerii inzerátu.`)
};

const en_settings_office_logo_hint = /** @type {(inputs: Settings_Office_Logo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WebP or SVG. Replaces the default Cerebrio mark in the app chrome, public site, and catalog letterhead. Not a property gallery photo.`)
};

/**
* | output |
* | --- |
* | "PNG, JPG, WebP or SVG. Replaces the default Cerebrio mark in the app chrome, public site, and catalog letterhead. Not a property gallery photo." |
*
* @param {Settings_Office_Logo_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_logo_hint = /** @type {((inputs?: Settings_Office_Logo_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Logo_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_logo_hint(inputs)
	return cs_settings_office_logo_hint(inputs)
});